/* eslint-disable camelcase */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getRechargeJobList = createAsyncThunk(
  'recharge/getRechargeJobList',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rc5_job_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getJobReward = createAsyncThunk(
  'recharge/getJobReward',
  async (p: {job_id: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rc5_job_reward', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getJobListRewards = createAsyncThunk(
  'recharge/getJobListRewards',
  async (p: any, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rc5_rewards_list', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getRechargeShopList = createAsyncThunk(
  'recharge/getRechargeShopList',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rc5_goods_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const exchangeRechargeGoods = createAsyncThunk(
  'recharge/exchangeRechargeGoods',
  async (p: {goods_id: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rc5_exchange_goods', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getLotteryInfo = createAsyncThunk(
  'recharge/getLotteryInfo',
  async (p: any, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rc5_lottery_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const lotteryPoint = createAsyncThunk(
  'recharge/lotteryPoint',
  async (p: any, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/rc5_lottery', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

interface StateProps {
  charge_sum: number // 累计充值金币数
  activity_expire: number // 活动倒计时
  job_list: Array<{
    id: number
    recharge_coins: number
    reward_coins: number
    reward_worth: number
    reward_level: number
    status: number
  }> // status, 0未完成， 1完成未领取， 2已领取
  score: number
  goods_category: Array<{
    name: string
    category: number // 类别: 1:礼物； 2：座驾; 3:头像框
    goods_list: Array<{
      id: number
      name: string
      icon: string
      score_need: number
      status: number
      worth: number
      num: number
    }>
  }>
  left_score: number // 抽奖转盘剩余积分
  per_cost: number // 每次抽奖需要积分
  prize_list: Array<{
    id: number
    name: string
    icon: string
  }>
  lottery_cnts: number[] // 抽奖次数 默认1
  broad_casts: string[]
  rewards_list: {item_list: {img: string; coins: string; desc: string}[]}[]
  ra_toast: string
}
const initState: StateProps = {
  charge_sum: 0, // 累计充值金币数
  activity_expire: 0, // 活动倒计时
  job_list: [], // status, 0未完成， 1完成未领取， 2已领取
  score: 0,
  goods_category: [],
  left_score: 0,
  per_cost: 0,
  prize_list: [],
  lottery_cnts: [1],
  broad_casts: [],
  rewards_list: [],
  ra_toast: '',
}

export const rankTastSlice = createSlice({
  name: 'rankTask',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRechargeJobList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getRechargeShopList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(exchangeRechargeGoods.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {score: data.score, left_score: data.score})
    })
    builder.addCase(getLotteryInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getJobListRewards.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(lotteryPoint.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {
        score: data.left_score,
        left_score: data.left_score,
      })
    })
  },
})

export default rankTastSlice.reducer
